import { Component, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';

@Component({
    selector: 'app-web-button',
    templateUrl: './web-button.component.html',
    styleUrls: ['./web-button.component.scss'],
})
export class WebButtonComponent {
    @Input() style: string = 'black';
    @Input() label: string = '';
    @Input() data: string = '';
    @Input() disabled: boolean = false;

    @Output() clicked: EventEmitter<string> = new EventEmitter<string>();

    @ViewChild('buttonElement') buttonElement: ElementRef;

    handleButtonClick() {
      if (!this.disabled) {
        this.clicked.emit(this.data);
      }
    }

    getClassList(): string[] {
      const classes = ['web-button', this.style];
      if (this.disabled) {
        classes.push('disabled');
      }
      return classes;
    }

    focus() {
      this.buttonElement.nativeElement.focus();
    }
}
